import { useEnumTranslation } from '@/hooks/useEnumTranslation';
import {
  invoiceDisplayStatus,
  invoiceDisplayStatusColor,
  type InvoiceDisplayStatusSource
} from '@/features/invoices/utils/invoice-display-status';
import type { BadgeColor } from '../badge-colors';

/** The badge an invoice card shows: label and colour. */
export interface InvoiceCardStatus {
  readonly label: string;
  readonly color: BadgeColor;
}

/** Labels an invoice card's state as lists and the detail do; none for a card stored without it. */
export function useInvoiceCardStatus(): (
  source: InvoiceDisplayStatusSource
) => InvoiceCardStatus | null {
  const tStatus = useEnumTranslation('invoiceDisplayStatus');
  return source => {
    if (!source.approvalStatus) return null;
    const status = invoiceDisplayStatus(source);
    return { label: tStatus(status), color: invoiceDisplayStatusColor(status) };
  };
}
